import { GetTitlesInput } from 'DVWebNodeUtils'
import { DetailPageActionTypes } from './constants'
import { getBtfInput, getAtfInputWithoutContext } from '../data/getDetailPageInputs'
import {
  actionOnGetTitles,
  actionOnGetDetailPage,
  GetDetailPageInputWithoutContext,
} from '../utils/wps'
import { getTitleInputForEpisodeRefresh } from '../data/getTitlesInputs'
import {
  NormalizeGetDetailPageType,
  NormalizeGetTitlesType,
} from '../data/normalize'
import { store } from '../store'

// Refresh main action box
export interface IRefreshMainActionBoxAction {
  type: typeof DetailPageActionTypes.RefreshAtfActionBox
  input: GetDetailPageInputWithoutContext
  output: NormalizeGetDetailPageType | null
}

export const refreshMainActionBox = (
  pageTitleId: string,
  isElcano: boolean,
  offerAsin?: string,
  canonicalTitleId?: string
) => {
  const input = getAtfInputWithoutContext({
    isElcano,
    titleID: pageTitleId,
    atfWidgets: ['BuyBox'],
  })

  return actionOnGetDetailPage(input, output => ({
    type: DetailPageActionTypes.RefreshAtfActionBox,
    input,
    output,
    payload: {
      offerAsin,
      canonicalTitleId,
    },
  }))
}

// Refresh full BTF action boxes
export interface IRefreshBtfAction {
  type: typeof DetailPageActionTypes.RefreshBtfActionBoxes
  input: GetDetailPageInputWithoutContext
  output: NormalizeGetDetailPageType | null
}

export const refreshBtfActionBoxes = (pageTitleId: string) => {
  const input = getBtfInput({
    context: store.getState().requestContext!,
    titleID: pageTitleId,
    isElcano: Boolean(store.getState().features.isElcano)
  })

  return actionOnGetDetailPage(input, output => ({
    type: DetailPageActionTypes.RefreshBtfActionBoxes,
    input,
    output,
  }))
}

// Refresh 1 Episode Action box
export interface IRefreshEpisodeAction {
  type: typeof DetailPageActionTypes.RefreshEpisode
  input: GetTitlesInput
  output: NormalizeGetTitlesType | null
}

export const refreshEpisode = (canonicalTitleId: string) => {
  const input = getTitleInputForEpisodeRefresh(
    store.getState().requestContext!,
    canonicalTitleId,
    Boolean(store.getState().features.isElcano)
  )

  return actionOnGetTitles(input, output => ({
    type: DetailPageActionTypes.RefreshEpisode,
    input,
    output,
  }))
}
